import { defineStore, StoreDefinition } from "pinia"
import { envConfigs, EnvType, EnvConfig } from "@/config"
import { getStorage, setStorage } from "@/utils"

const CURRENT_ENV = `${process.env.APP_ENV}_current_env`

const setActiveEnvByAppEnvIfNot = (envs: EnvConfig[]): EnvConfig[] => {
	const index = envs.findIndex(item => item.active)
	if (index !== -1) return envs
	const appEnv = (process.env.APP_ENV ||
		process.env.NODE_ENV) as unknown as EnvType
	const envIndex = envs.findIndex(item => item.env === appEnv)
	if (envIndex !== -1) {
		envs[envIndex].active = true
	}
	return envs
}

const getEnvs = (): EnvConfig[] => {
	// 从本地存储中获取
	const storageEnv = getStorage<EnvConfig>(CURRENT_ENV)!
	const index = envConfigs.findIndex(item => item.env === storageEnv?.env)
	if (index !== -1) {
		envConfigs[index] = storageEnv
	}
	return setActiveEnvByAppEnvIfNot(envConfigs)
}

export type EnvStore = ReturnType<
	StoreDefinition<string, EnvStoreState, EnvStoreGetters, EnvStoreActions>
>
export declare interface EnvStoreState {
	visible: boolean
	envs: EnvConfig[]
}

export declare interface EnvStoreActions {
	setEnvVisible: (visible: boolean) => void
	setEnv: (env: EnvType) => void
	// keyboardToggleEnv: (keyboardShortcuts: string) => void
}

export declare interface EnvStoreGetters {
	current: (this: EnvStore, state: EnvStoreState) => EnvConfig
	isDev: (this: EnvStore, state: EnvStoreState) => boolean
	isTest: (this: EnvStore, state: EnvStoreState) => boolean
	isProd: (this: EnvStore, state: EnvStoreState) => boolean
	isMock: (this: EnvStore, state: EnvStoreState) => boolean
	[key: string]: any
}

export const useEnvStore = defineStore<
	string,
	EnvStoreState,
	EnvStoreGetters,
	EnvStoreActions
>("env", {
	state: () => {
		return {
			visible: false,
			envs: getEnvs()
		}
	},
	actions: {
		setEnvVisible(visible: boolean) {
			this.visible = visible
		},
		setEnv(env: EnvType) {
			this.envs.forEach(item => {
				item.active = item.env === env
			})
			setStorage(CURRENT_ENV, this.current)
		}
	},
	getters: {
		current: state => {
			const envs = state.envs.filter(item => item.active)
			return envs[0]
		},
		isDev() {
			return this.current.env === "development"
		},
		isTest() {
			return this.current.env === "test"
		},
		isProd() {
			return this.current.env === "production"
		},
		isMock() {
			return this.current.env === "mock"
		}
	}
})
